import AiLabel from "@/components/ai-label";
import Category from "@/components/category";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import Image from "next/image";
import Link from "next/link";

type SmallProps = {
  article: Content.Article;
};

const Small = (props: SmallProps) => {
  const category = props.article.fields.categories?.[0];
  const image =
    props.article.fields.teaserImage || props.article.fields.images?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;

  return (
    <Link
      href={`/${props.article.fields.slug}`}
      className="group relative overflow-hidden"
    >
      <div className="grid grid-cols-12 gap-2">
        <div className="col-span-8">
          {category && <Category category={category} />}
          {title && (
            <TeaserHeading text={title} className="text-lg font-semibold" />
          )}
        </div>
        <div className="col-span-4">
          {image?.fields?.file?.url && (
            <div className="relative w-full aspect-h-9 aspect-w-16">
              <div className="">
                <Image
                  fill
                  src={createImageUrl(image.fields.file.url, { crop: "16:9" })}
                  alt={image.fields.alt || ""}
                  className="object-cover"
                  sizes={createImageSizes({
                    mobile: "33vw",
                    tablet: "33vw",
                    desktop: "33vw",
                  })}
                />
                <AiLabel image={image} size="sm" />
              </div>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default Small;
